
import React from 'react';
import { ArrowRight, Facebook } from 'lucide-react';
import 'primeicons/primeicons.css';

function Hero() {
  return (
    <section className="hero is-medium" style={{
      background: "linear-gradient(to bottom, var(--marter-gray), white)",
      paddingTop: "6rem"
    }}>
      <div className="hero-body">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-6">
              <h1 className="title is-1 has-text-marter-dark-blue mb-4" style={{ lineHeight: 1.2 }}>
                Helping You Profit on Walmart
              </h1>
              <p className="subtitle is-5 has-text-marter-dark-gray mb-5">
                Join thousands of sellers, brands, and companies using Marter's solutions to sell on Walmart with ease.
              </p>
              <div className="buttons">
                <a className="button is-marter-blue is-medium solutionsBtn" href="#solutions">
                  Explore Solutions
                </a>
                <a className="button is-outlined is-medium">
                  <span style={{ color: "#FECA1C" }} onClick={() => window.open("https://www.youtube.com/watch?v=K1_n5iCudmg")}>View Demo</span>
                  <span className="icon">
                    <ArrowRight size={20} color="#FECA1C" />
                  </span>
                </a>
              </div>
              <div className="mt-5 is-flex is-align-items-center">
                <p className="has-text-marter-dark-gray is-size-7">
                  <span className="has-text-weight-bold">5,000+</span> sellers are already profiting with Marter's solutions.
                </p>
              </div>
              <div className="mt-5 is-flex is-align-items-center">
                <p className="has-text-marter-dark-gray is-size-7">
                  <button
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      padding: '10px 20px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s',
                      textDecoration: 'none'
                    }}
                    onClick={() => window.open('https://www.facebook.com/share/g/hr6idZ8zRkis9FKE/', '_blank')}
                  >
                    <i className="pi pi-facebook" style={{ color: 'white', marginRight: '8px', fontSize: 24 }} />
                    Join our community
                  </button>
                  <button
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      padding: '10px 20px',
                      backgroundColor: '#7289DA',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s',
                      textDecoration: 'none',
                      marginLeft: '20px'
                    }}
                    onClick={() => window.open('https://discord.gg/9VfPNDyM9h', '_blank')}
                  >
                    <i className="pi pi-discord" style={{ color: 'white', marginRight: '8px', fontSize: 24 }} />
                    Join our community
                  </button>
                </p>
              </div>
            </div>
            <div className="column is-6">
              <div className="card" style={{
                borderRadius: "1rem",
                padding: "1.5rem",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  top: "-1rem",
                  left: "-1rem",
                  width: "6rem",
                  height: "6rem",
                  borderRadius: "50%",
                  backgroundColor: "var(--marter-blue)",
                  opacity: 0.2
                }}></div>
                <div style={{
                  position: "absolute",
                  bottom: "-1rem",
                  right: "-1rem",
                  width: "8rem",
                  height: "8rem",
                  borderRadius: "50%",
                  backgroundColor: "var(--marter-light-blue)",
                  opacity: 0.2
                }}></div>
                <div style={{
                  position: "relative",
                  zIndex: 10,
                  aspectRatio: "16/9",
                  backgroundColor: "var(--marter-gray)",
                  borderRadius: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  <iframe style={{ width: "100%", height: "100%" }} src="https://www.youtube.com/embed/K1_n5iCudmg?si=qobZy7a122ypog6K" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
